import gql from 'graphql-tag'

export const GET_SCHOOL_TREE = gql`
  query SchoolsTree {
    SchoolsTree {
      jsonData
    }
  }
`

export const GET_SCHOOL_INFO = gql`
  query schoolInfo($id: Int!) {
    schoolInfo(id: $id) {
      id
      name
      staffSize
      agesTo
      agesFrom
      website
      address
      population
      countryCode
      centerCode
      parentId

      schoolProfile {
        email
        phone
      }
    }
  }
`
export const GET_SCHOOL_STAFF_DESIGNATIONS = gql`
  query academySchoolStaffDesignations($schoolIds: [Int!]!) {
    academySchoolStaffDesignations(schoolIds: $schoolIds) {
      designations
    }
  }
`

export const GET_SCHOOL_REPORTING_OFFICERS = gql`
  query academyReportingOfficers($schoolId: Int!) {
    academyReportingOfficers(schoolId: $schoolId) {
      id
      userId
      name
      email
      designation
      dateJoin
      qualificationLevels
      yearOfExp
      agesFrom
      agesTo
      title
      manager {
        id
        userId
        designation
        name
        media {
          url
        }
      }
      school {
        id
        name
      }
      appraisalAssigns {
        id
        insertedAt
        updatedAt
        startDate
        endDate
        status
        appraisal {
          type
          id
          name
          standard
        }
      }
      roles {
        id
        startDate
        endDate
        role {
          id
          name
          permissions
        }
      }
      media {
        id
        url
        fileName
      }
      user {
        id
        status
        userRoles {
          name
          startDate
          endDate
          module
          schoolId
        }
        personalProfiles {
          id
          title
          name
          designation
          school {
            id
          }
          media {
            url
          }
          user {
            userRoles {
              name
            }
          }
        }
      }
    }
  }
`

export const GET_SCHOOL_STAFFS = gql`
  query academySchoolStaffs($schoolIds: [Int!]!, $search: String, $designation: String, $limit: Int, $page: Int) {
    academySchoolStaffs(schoolIds: $schoolIds, search: $search, designation: $designation, limit: $limit, page: $page) {
      meta {
        total
        page
        limit
      }
      data {
        id
        userId
        name
        email
        designation
        dateJoin
        qualificationLevels
        yearOfExp
        agesFrom
        agesTo
        title
        manager {
          id
          userId
          designation
          name
          media {
            url
          }
        }
        school {
          id
          name
        }
        roles {
          id
          startDate
          endDate
          role {
            id
            name
            permissions
          }
        }
        media {
          id
          url
          fileName
        }
        user {
          id
          status
          userRoles {
            name
            startDate
            endDate
            module
            schoolId
          }
          personalProfiles {
            id
            title
            name
            designation
            school {
              id
            }
            media {
              url
            }
            user {
              userRoles {
                name
              }
            }
          }
        }
      }
    }
  }
`

export const GET_PROFILE_SCHOOL_STAFFS = gql`
  query academySchoolStaffProfiles($schoolId: Int!, $staffIds: [Int!]) {
    academySchoolStaffProfiles(schoolId: $schoolId, staffIds: $staffIds) {
      id
      userId
      name
      email
      designation
      dateJoin
      qualificationLevels
      yearOfExp
      agesFrom
      agesTo
      title
      manager {
        id
        userId
        name
        media {
          url
        }
      }
      roles {
        startDate
        endDate
        role {
          name
          permissions
        }
      }
      media {
        id
        url
        fileName
      }
    }
  }
`

export const WORKING_HOURS = gql`
  query academyStaffConfig($schoolId: Int!) {
    academyStaffConfig(schoolId: $schoolId) {
      schoolId
      workingHours
    }
  }
`
